import { enumBSFlagOptions, enumBranchStyle } from "../constants";

export function PreProcessBranchRule(rule, scm, nodeList) {
  var bsOption = rule.GetBranchStyleFlag();
  //NOTE: This ugly switch statement is needed to translate what was originally just the assistant handling into full -on branch style handling.
  switch (bsOption) {
    case enumBSFlagOptions.leftpeerassist:
    case enumBSFlagOptions.rightpeerassist:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.SetPeerAssist(nodeList[i], bsOption);
      break;
    case enumBSFlagOptions.treestyle:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.tree);
      break;
    case enumBSFlagOptions.stagger:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.stagger);
      break;
    case enumBSFlagOptions.banded:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.banded);
      break;
    case enumBSFlagOptions.twocolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.twocolumn);
      break;
    case enumBSFlagOptions.fourcolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.fourcolumn);
      break;
    case enumBSFlagOptions.sixcolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.sixcolumn);
      break;
    case enumBSFlagOptions.eightcolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.eightcolumn);
      break;
    case enumBSFlagOptions.twelvecolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.twelvecolumn);
      break;
    case enumBSFlagOptions.sixteencolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.sixteencolumn);
      break;
    case enumBSFlagOptions.twentycolumn:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.twentycolumn);
      break;
    case enumBSFlagOptions.onecolumncenterright:
      var n = nodeList.length;
      for (var i = 0; i < n; i++)
        scm.ForceBranchStyle(nodeList[i], enumBranchStyle.onecolumncenterright);
      break;
    case enumBSFlagOptions.onecolumncenterleft:
      var n = nodeList.length;
      for (var i = 0; i < n; i++)
        scm.ForceBranchStyle(nodeList[i], enumBranchStyle.onecolumncenterleft);
      break;
    case enumBSFlagOptions.onecolumnright:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.onecolumnright);
      break;
    case enumBSFlagOptions.onecolumnleft:
      var n = nodeList.length;
      for (var i = 0; i < n; i++) scm.ForceBranchStyle(nodeList[i], enumBranchStyle.onecolumnleft);
      break;
  }
}
